var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 55,
    viewBox: "0 0 99 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 5.63006C1.32812 3.18894 3.30704 1.21002 5.74816 1.21002C8.18928 1.21002 10.1682 3.18894 10.1682 5.63006V29.6246H1.32812V5.63006Z",
    fill: "url(#paint0_linear_218_87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1577 30.496C45.9953 30.8496 48.3523 28.3803 47.5673 25.6306C46.0263 20.233 43.4053 14.1486 39.9644 11.4543C35.2319 7.74862 29.2735 5.95895 23.2785 6.44254C17.2835 6.92613 11.693 9.64742 7.6229 14.0632C3.55281 18.479 1.30256 24.2644 1.32132 30.2646C1.34009 36.2648 3.62649 42.0383 7.72413 46.4328C11.8218 50.8273 17.4292 53.5194 23.4271 53.9717C29.425 54.424 35.3722 52.6033 40.0814 48.873C43.623 46.0677 46.2684 42.3375 47.7526 38.1381C48.5679 35.8312 46.8717 33.5449 44.4536 33.1716C42.0362 32.7985 39.8296 34.5065 38.7672 36.7097C37.7912 38.7339 36.3632 40.5308 34.5703 41.951C31.607 44.2983 27.8647 45.444 24.0905 45.1594C20.3163 44.8747 16.7877 43.1807 14.2093 40.4155C11.6308 37.6502 10.1921 34.0171 10.1802 30.2415C10.1684 26.4658 11.5844 22.8253 14.1456 20.0466C16.7067 17.268 20.2246 15.5556 23.997 15.2513C27.7693 14.947 31.5187 16.0731 34.4967 18.405C36.7153 20.1422 38.3298 23.7119 39.2571 26.961C39.7804 28.7947 41.2655 30.2603 43.1577 30.496Z",
    fill: "url(#paint1_linear_218_87)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9336 5.63006C88.9336 3.18894 90.9125 1.21002 93.3536 1.21002C95.7948 1.21002 97.7737 3.18894 97.7737 5.63006V31.2031H88.9336V5.63006Z",
    fill: "url(#paint2_linear_218_87)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6943 33.1901C52.2733 33.4965 50.5199 35.7293 51.2674 38.0524C52.6324 42.2952 55.1704 46.1007 58.6284 49.005C63.2227 52.8637 69.1032 54.8479 75.096 54.5616C81.0889 54.2753 86.7535 51.7396 90.959 47.4606C95.1646 43.1816 97.6018 37.474 97.7843 31.477C97.9667 25.4801 95.881 19.6349 91.9434 15.1081C88.0058 10.5813 82.5059 7.7059 76.5415 7.0558C70.5771 6.40569 64.5869 8.02869 59.7665 11.6009C56.2878 14.1788 53.4854 20.1772 51.7763 25.5323C50.9022 28.2712 53.2709 30.7801 56.1163 30.3686C57.888 30.1124 59.2762 28.7483 59.8389 27.0489C60.8944 23.8611 62.7259 20.4072 65.0282 18.7011C68.0614 16.4532 71.8308 15.4319 75.5839 15.841C79.3371 16.2501 82.7979 18.0595 85.2757 20.908C87.7535 23.7565 89.0659 27.4346 88.9511 31.2083C88.8363 34.9819 87.3026 38.5734 84.6562 41.266C82.0099 43.9586 78.4454 45.5542 74.6744 45.7344C70.9033 45.9145 67.203 44.666 64.312 42.2379C62.5605 40.7669 61.1841 38.9284 60.2658 36.8748C59.2696 34.6471 57.1153 32.8837 54.6943 33.1901Z",
    fill: "url(#paint3_linear_218_87)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6719 48.3333H94.8953C95.1574 48.3333 95.3833 48.3944 95.5729 48.5165C95.7643 48.6361 95.9118 48.8132 96.0152 49.0476C96.1204 49.2796 96.173 49.5653 96.173 49.9047C96.173 50.1563 96.1359 50.3846 96.0618 50.5897C95.9876 50.7949 95.8842 50.9658 95.7514 51.1026C95.6203 51.2393 95.4686 51.3333 95.2962 51.3846L95.1875 51.4469H93.8814L93.8762 51.0586H94.9651C95.1634 51.0586 95.3281 51.0049 95.4591 50.8974C95.5902 50.7875 95.6885 50.6447 95.754 50.4689C95.8212 50.293 95.8549 50.105 95.8549 49.9047C95.8549 49.5409 95.7721 49.2527 95.6066 49.0403C95.4427 48.8278 95.2057 48.7216 94.8953 48.7216H93.9926V53.6667H93.6719V48.3333ZM95.9945 53.6667L95.022 51.282L95.3634 51.2747L96.3359 53.619V53.6667H95.9945Z",
    fill: "url(#paint4_linear_218_87)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 51C99 53.2091 97.2109 55 95.0039 55C92.7969 55 91.0078 53.2091 91.0078 51C91.0078 48.7908 92.7969 47 95.0039 47C97.2109 47 99 48.7908 99 51ZM95 54.5C97.053 54.5 98.5 53.055 98.5 51C98.5 48.945 97.053 47.5 95 47.5C92.947 47.5 91.5 48.945 91.5 51C91.5 53.055 92.947 54.5 95 54.5Z",
    fill: "#F583EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_87",
    x1: 0.981455,
    y1: -1.10277,
    x2: 10.9139,
    y2: -1.03983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_87",
    x1: 2.42764,
    y1: -0.0126917,
    x2: 55.6752,
    y2: 6.58052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_87",
    x1: 88.5869,
    y1: -1.23126,
    x2: 98.5194,
    y2: -1.17164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_87",
    x1: 101.53,
    y1: 56.6129,
    x2: 48.0819,
    y2: 59.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_218_87",
    x1: 93.5674,
    y1: 47.8992,
    x2: 96.5605,
    y2: 47.9297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe23b80e11da2c239b0d16d0cf9d47cc.svg";
export { ForwardRef as ReactComponent };